import { render, staticRenderFns } from "./MTop.vue?vue&type=template&id=5e273cc3&scoped=true&"
import script from "./MTop.vue?vue&type=script&lang=js&"
export * from "./MTop.vue?vue&type=script&lang=js&"
import style0 from "./MTop.vue?vue&type=style&index=0&id=5e273cc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e273cc3",
  null
  
)

export default component.exports